import { NumberInputProps } from '@procore/core-react/dist/_typedoc/NumberInput/NumberInput.types.json';
import * as React from 'react';
export default {
  NumberInputProps,
  React
};